import { render, staticRenderFns } from "./SupplierPayment.vue?vue&type=template&id=23a78a62&scoped=true"
import script from "./SupplierPayment.vue?vue&type=script&lang=js"
export * from "./SupplierPayment.vue?vue&type=script&lang=js"
import style0 from "./SupplierPayment.vue?vue&type=style&index=0&id=23a78a62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a78a62",
  null
  
)

export default component.exports